import CreatePassword from '@/components/auth/create-password/CreatePassword.vue';
import ForgotPassword from '@/components/auth/forgot-password/ForgotPassword.vue';
import MerchantSignUp from '@/components/auth/merchant-sign-up/MerchantSignUp.vue';
import OtpVerification from '@/components/auth/otp-verification/OtpVerification.vue';
import SignIn from '@/components/auth/sign-in/SignIn.vue';
import VerifyEmail from '@/components/auth/verify-email/VerifyEmail.vue';
import CancellationsTable from '@/components/merchant/cancellations/cancellations-table/CancellationsTable.vue';
import DashboardHome from '@/components/merchant/home/home-page/HomePage.vue';
import InvoiceDetails from '@/components/merchant/invoices/invoice-details/InvoiceDetails.vue';
import InvoicesTable from '@/components/merchant/invoices/invoices-table/InvoicesTable.vue';
import OrderDetails from '@/components/merchant/orders/order-details/OrderDetails.vue';
import OrdersWrapper from '@/components/merchant/orders/OrderWrapper.vue';
import PaymentsTable from '@/components/merchant/payments-table/payments-table/PaymentsTable.vue';
import SettingsComponent from '@/components/merchant/settings/SettingsComponent.vue';
import SettlementsDetails from '@/components/merchant/settlements/settlements-details/SettlementsDetails.vue';
import SettlementsTable from '@/components/merchant/settlements/settlements-table/SettlementsTable.vue';
import MerchantAuth from '@/views/MerchantAuth.vue';
import type { RouteRecordRaw } from 'vue-router';
import MerchantDashboardLayout from '../layouts/MerchantDashboardLayout.vue';
import { authGuard } from '../utils/auth.utils';
import { initializeMerchantGuard } from '../utils/merchant.utils';

export const merchantRoutes: RouteRecordRaw = {
  path: '/merchant',
  children: [
    {
      path: 'auth',
      name: 'MerchantAuth',
      component: MerchantAuth,
      redirect: 'merchant/auth/sign-in',
      children: [
        { path: 'sign-in', name: 'merchantSignIn', component: SignIn, beforeEnter: authGuard },
        { path: 'sign-up', name: 'merchantSignUp', component: MerchantSignUp },
        { path: 'forgot-password', name: 'merchantForgotPassword', component: ForgotPassword },
        {
          path: 'otp-verification',
          name: 'merchantOtpVerification',
          component: OtpVerification,
        },
        {
          path: 'create-password',
          name: 'merchantCreatePassword',
          component: CreatePassword,
          meta: { requiresAuth: true },
        },
        {
          path: 'verify-email',
          name: 'merchantVerifyEmail',
          component: VerifyEmail,
        },
      ],
    },
    {
      path: '',
      name: 'merchantDashboard',
      component: MerchantDashboardLayout,
      meta: { requiresAuth: true },
      beforeEnter: initializeMerchantGuard,
      children: [
        {
          path: '',
          name: 'merchantDashboardHome',
          component: DashboardHome,
        },
        {
          path: 'orders',
          name: 'merchantOrders',
          component: OrdersWrapper,
        },
        {
          path: 'orders/:id',
          name: 'merchantOrderDetails',
          component: OrderDetails,
        },
        {
          path: 'payments',
          name: 'merchantPayments',
          component: PaymentsTable,
        },
        {
          path: 'invoices',
          name: 'merchantInvoices',
          component: InvoicesTable,
        },
        {
          path: 'invoices/:id',
          name: 'merchantInvoiceDetails',
          component: InvoiceDetails,
        },
        {
          path: 'settlements',
          name: 'merchantSettlements',
          component: SettlementsTable,
        },
        {
          path: 'settlements/:id',
          name: 'merchantSettlementsDetails',
          component: SettlementsDetails,
        },
        {
          path: 'cancellations',
          name: 'merchantCancellations',
          component: CancellationsTable,
        },
        {
          path: 'settings',
          name: 'merchantSettings',
          component: SettingsComponent,
        },
      ],
    },
  ],
};
